module.exports = __webpack_public_path__ + "static/img/speaker-national.a378e6bc.png";